import { getMessages } from '../../../../../../store/constants';

export const BOARD_SECTION_TAGS = getMessages().getText('board_settings.tags.title');
export const BOARD_SECTION_TAG_DELETE = getMessages().getText('board_settings.tag.delete');
export const BOARD_SECTION_TAGS_EMPTY = getMessages().getText('board_settings.tag.empty');
